<template>
  <j-modal
    :title="title"
    :width="800"
    :visible="visible"
    :confirmLoading="confirmLoading"
    switchFullscreen
    @ok="handleOk"
    @cancel="handleCancel"
    :cancelText="$t('关闭')">
    <template slot="footer">
      <a-button key="close" @click="handleCancel">
        {{ $t('关闭') }}
      </a-button>
    </template>
    <a-spin :spinning="confirmLoading">
      <div class="form-contain" style="height: auto">
        <a-tabs v-model="activeKey" @change="changeTab">
          <a-tab-pane v-for="item in tabList" :key="item.key" :tab="item.title">
            <div v-if="activeKey == 1" style="height: calc(70vh - 90px);overflow-y: auto;padding-top:8px">
              <detail-list :col="2" size="small">
                <detail-list-item :term="$t('设备编号')">{{model.meterid}}</detail-list-item>
                <!--<detail-list-item term="告警状态">{{model.metertype == 1||model.metertype == 3?pressWarnList[model.warnstatus]:waterWarnList[model.warnstatus]}}</detail-list-item>-->
                <detail-list-item :term="$t('告警状态')">
                  <span v-if="model.warnstatus == 0" class="normalbg-status">{{ $t('正常') }}</span>
                  <span v-else class="unusualbg-status">{{model.datainfo}}</span>
                </detail-list-item>
                <detail-list-item :term="$t('上传时间')">{{model.systime}}</detail-list-item>
                <detail-list-item :term="$t('表端时间')">{{model.metertime}}</detail-list-item>
                <detail-list-item :term="$t('表类型')">{{'wq_device_type'|filterDictTextByCache(model.deviceType)}}</detail-list-item>
                <detail-list-item :term="$t('上报方式')">{{tuopuruiSendWayObj[model.metersendway]?$t(tuopuruiSendWayObj[model.metersendway]): $t('未知')}}</detail-list-item>
                <detail-list-item :term="model.deviceType == 'PM'?$t('压力值(MPa)'): $t('液位值(m)')">
                  {{model.pvalue}}
                  ({{$t('下限值')}}：
                  <span v-if="model.pvalueLow==null">--</span>
                  <span v-else>{{model.pvalueLow}}{{model.deviceType == 'PM'?'MPa':'m'}}</span>
                  ，{{$t('上限值')}}：<span v-if="model.pvalueTop==null">--</span>
                  <span v-else>{{model.pvalueTop}}{{model.deviceType == 'PM'?'MPa':'m'}}</span>
                  )
                </detail-list-item>
                <detail-list-item :term="$t('温度值(℃)')">
                  {{model.tepvalue}}
                  ({{$t('下限值')}}：
                  <span v-if="model.tepvalueLow==null">--</span>
                  <span v-else>{{model.tepvalueLow}}℃</span>
                  ，{{$t('上限值')}}：<span v-if="model.tepvalueTop==null">--</span>
                  <span v-else>{{model.tepvalueTop}}℃</span>
                  )
                </detail-list-item>

                <detail-list-item :term="model.deviceType == 'PM'?$t('压力波动报警值(MPa)'):$t('液位波动报警值(m)')">{{model.pvalueWave}}</detail-list-item>
                <detail-list-item :term="$t('温度波动报警值(℃)')">{{model.tepvalueWave}}</detail-list-item>
                <detail-list-item :term="model.deviceType == 'PM'?$t('压力恢复报警值(MPa)'):$t('液位恢复报警值(m)')">{{model.pvalueRenew}}</detail-list-item>
                <detail-list-item :term="$t('温度恢复报警值(℃)')">{{model.tepvalueRenew}}</detail-list-item>
                <detail-list-item :term="$t('上传时间(分钟)')">{{model.reportInterval}}</detail-list-item>
                <detail-list-item :term="$t('采样时间(*10秒)')">{{model.sampleInterval}}</detail-list-item>
                <detail-list-item :term="$t('电压值(%)')">{{model.battery}}</detail-list-item>
                <detail-list-item :term="$t('信号值')">{{model.signDb}}</detail-list-item>
                <detail-list-item :term="$t('电池状态')">
                  <span :class="model.batterystatus == 0?'normalbg-status':'unusualbg-status'">{{batterystatusList[model.batterystatus]}}</span>
                </detail-list-item>
                <detail-list-item :term="$t('传感器状态')">
                  <span :class="model.sensorstatus == 0?'normalbg-status':'unusualbg-status'">{{sensorstatusList[model.sensorstatus]}}</span>
                  </detail-list-item>
                <!--<detail-list-item  :col="1" term="备注">{{model.remark}}</detail-list-item>-->
              </detail-list>
            </div>
            <a-table
              v-else-if="activeKey == 2"
              ref="table"
              size="middle"
              :scroll="{x: true}"
              bordered
              rowKey="id"
              :columns="columns"
              :dataSource="dataSource"
              :pagination="ipagination"
              :loading="loading"
              class="j-table-force-nowrap"
              @change="handleTableChange"
              >
              <span slot="action" slot-scope="text, record">
                <a @click="handleDetail(record)">{{ $t('详情') }}</a>
              </span>
            </a-table>
            <div v-else-if="activeKey == 3">
              <!-- <a-radio-group v-model="dateFlag" style="margin-bottom: 16px" @change="queryLineData">
                <a-radio-button v-for="(item,key) in dateFlags" :value="key" :key="key">{{item}}</a-radio-button>
              </a-radio-group> -->
              <a-form layout="inline" @keyup.enter.native="queryLineData">
                <a-row :gutter="24">
                  <a-col :span="8">
                    <a-form-model-item :label="$t('上报时间')">
                      <a-range-picker
                        v-model="date"
                        :placeholder="[$t('查询起始时间'), $t('查询结束时间')]"
                        format="YYYY-MM-DD"
                        @change="onDateRangeChange"
                      />
                    </a-form-model-item>
                  </a-col>
                  <a-col :xl="6" :lg="7" :md="8" :sm="24">
                    <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                      <a-button type="primary" @click="queryLineData" icon="search">{{ $t('查询') }}</a-button>
                    </span>
                  </a-col>
                </a-row>
              </a-form>
              <div style="height: 300px;">
                <Echart ref="option" :options="option" style="height: 100%"></Echart>
              </div>
              <div style="height: 300px;margin-top: 10px;background-color: honeydew">
                <Echart ref="option2" :options="option2" style="height: 100%"></Echart>
              </div>
            </div>
          </a-tab-pane>
        </a-tabs>
      </div>
      <part-pw-history-meterdatarecord-modal ref="modalForm" @ok="modalFormOk"></part-pw-history-meterdatarecord-modal>
    </a-spin>
  </j-modal>
</template>

<script>

  import DetailList from '@/components/tools/DetailList'
  const DetailListItem = DetailList.Item
  import {tuopuruiSendWayObj} from '@/utils/constants/protocolConstant'
  import {filterDictTextByCache} from '@/components/dict/JDictSelectUtil'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import PartPwHistoryMeterdatarecordModal from './PartPwHistoryMeterdatarecordModal'
  import {isNull,isUndefined,isUndefinedAndNull} from '@/utils/validate'
  import { getAction } from '@/api/manage'
  import { formatTime,cloneObject } from "@/utils/util"

  export default {
    name: 'PartPwMeterdatarecordModal',
    filters: {
      filterDictTextByCache
    },
    mixins:[JeecgListMixin],
    components: {
      DetailList,
      DetailListItem,
      PartPwHistoryMeterdatarecordModal,
    },
    data () {
      return {
        tuopuruiSendWayObj,
        width:800,
        visible: false,
        disableSubmit: false,
        model: {},
        confirmLoading: false,
        validatorRules: {
        },
        url: {
          add: "/jeecg-charge/meter/partPwHistoryMeterdatarecord/add",
          edit: "/jeecg-charge/meter/partPwHistoryMeterdatarecord/edit",
          queryById: "/jeecg-charge/meter/partPwHistoryMeterdatarecord/queryById",
          list: '/jeecg-charge/wq/partPWHistoryMeterdatarecord/list',
          queryPmMeterdatarecordLineStatistical: '/jeecg-charge/pw/queryPmMeterdatarecordLineStatistical'
        },
        activeKey: 1,
        disableMixinCreated: true,
        uniqueParam: {},

        dateFlag:'3',
        option: {},
        option2: {},
        lineData: {},
        dateType: 2
      }
    },
    computed: {
      title() {
        return this.$t('详情')
      },
      metertypeList() {
        return {1: this.$t('NB压力表'),2: this.$t('NB液位计'),3: this.$t('4G压力表'),4: this.$t('4G液位计')}
      },
      batterystatusList() {
        return {0: this.$t('正常'),1: this.$t('欠压')}
      },
      sensorstatusList() {
        return {0: this.$t('正常'),1: this.$t('异常')}
      },
      waterWarnList() {
        return {'-1': this.$t('离线'),0: this.$t('正常'),10: this.$t('液位下限报警'),20: this.$t('液位上限报警'),1: this.$t('温度下限报警'),2: this.$t('温度上限报警'),
        11: this.$t('液位下限报警、温度下限报警'),12: this.$t('液位下限报警、温度上限报警'),21: this.$t('液位上限报警 温度下限报警'),22: this.$t('液位上限报警 温度上限报警'),9: this.$t('电池电量报警')}
      },
      pressWarnList() {
        return {'-1': this.$t('离线'),0: this.$t('正常'),10: this.$t('压力下限报警'),20: this.$t('压力上限报警'),1: this.$t('温度下限报警'),2: this.$t('温度上限报警'),
        11: this.$t('压力下限报警、温度下限报警'),12: this.$t('压力下限报警、温度上限报警'),21: this.$t('压力上限报警 温度下限报警'),22: this.$t('压力上限报警 温度上限报警'),9: this.$t('电池电量报警')}
      },
      tabList() {
        return [
          {key: 1,title: this.$t('基本信息')},
          {key: 2,title: this.$t('历史数据')},
          {key: 3,title: this.$t('图形展示')}
        ]
      },
      dateFlags() {
        return { 1: this.$t('今日'), 3: this.$t('近三天'), 7: this.$t('近一周')}
      },
      columns() {
        return [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender: (t,r,index) => {
              return parseInt(index)+1;
            }
          },
          {
            title: this.$t('设备编号'),
            align:"center",
            dataIndex: 'meterid'
          },
          {
            title: this.$t('仪表类型'),
            align:"center",
            dataIndex: 'deviceType',
            customRender: (text) => {
              return filterDictTextByCache('wq_device_type', text);
              //let obj = {1: 'NB压力表',2: 'NB液位计',3: '4G压力表',4: '4G液位计'}
              //return obj[text]?obj[text]: '未知'
            }
          },
          {
            title: this.$t('压力值/液位值'),
            align:"center",
            dataIndex: 'pvalue'
          },
          {
            title: this.$t('温度值'),
            align:"center",
            dataIndex: 'tepvalue'
          },
          {
            title: this.$t('电量 %'),
            align:"center",
            dataIndex: 'battery'
          },
          {
            title: this.$t('信号值'),
            align:"center",
            dataIndex: 'signDb'
          },
          {
            title: this.$t('上报时间'),
            align:"center",
            dataIndex: 'systime'
          },
          {
            title: this.$t('电池状态'),
            align:"center",
            dataIndex: 'batterystatus',
            customRender: (text) => {
              let obj = {0: this.$t('正常'),1: this.$t('欠压')}
              return obj[text]?obj[text]: this.$t('未知')
            }
          },
          {
            title: this.$t('上报方式'),
            align:"center",
            dataIndex: 'metersendway',
            customRender: (text) => {
              let obj = tuopuruiSendWayObj;
              return obj[text]?this.$t(obj[text]): this.$t('未知')
            }
          },
          {
            title: this.$t('传感器状态'),
            align:"center",
            dataIndex: 'sensorstatus',
            customRender: (text) => {
              let obj = {0: this.$t('正常'),1: this.$t('异常')}
              return obj[text]?obj[text]: this.$t('未知')
            }
          },/*
          {
            title:'告警状态',
            align:"center",
            dataIndex: 'warnstatus',
            customRender:function (text,record) {
              let waterWarn = {'-1': '离线',0: '正常',10: '液位下限报警',20: '液位上限报警',1: '温度下限报警',2: '温度上限报警',
                11: '液位下限报警、温度下限报警',12: '液位下限报警、温度上限报警',21: '液位上限报警 温度下限报警',22: '液位上限报警 温度上限报警',9:'电池电量报警'};
              let pressWarn = {'-1': '离线',0: '正常',10: '压力下限报警',20: '压力上限报警',1: '温度下限报警',2: '温度上限报警',
                11: '压力下限报警、温度下限报警',12: '压力下限报警、温度上限报警',21: '压力上限报警 温度下限报警',22: '压力上限报警 温度上限报警',9:'电池电量报警'};
              if(record.metertype == 1||record.metertype == 3) {
                return pressWarn[text]?pressWarn[text]: '未知'
              }else if(record.metertype == 2||record.metertype == 4){
                return waterWarn[text]?waterWarn[text]: '未知'
              }
            }
          },*/
          {
            title: this.$t('告警状态'),
            align:"center",
            dataIndex: 'datainfo',
            customRender: (text,record) => {
              if(record.warnstatus == 0){
                return this.$t("正常");
              }else{
                return text;
              }
            }
          },
          {
            title: this.$t('操作'),
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:147,
            scopedSlots: { customRender: 'action' }
          }
        ]
      },
    },
    created () {
    },
    methods: {
      close () {
        this.$emit('close');
        this.activeKey = 1;
        this.confirmLoading = false;
        this.visible = false;
      },
      add () {
        this.edit({});
      },
      edit (record) {
        this.model = Object.assign({}, record);
        this.uniqueParam.deviceId = this.model.meterid
        this.visible = true;
      },
      handleOk () {
        const that = this;
      },
      handleCancel () {
        this.close()
      },
      changeTab() {
        if(this.activeKey == 2) {
          this.loadData(1)
        }else if(this.activeKey == 3) {
          this.date = [formatTime(new Date(),'yyyy-MM-dd'),formatTime(new Date(),'yyyy-MM-dd')]
          this.queryParam.beginDate = this.date[0]
          this.queryParam.endDate = this.date[1]
          this.queryLineData()
        }
      },
      setLineMax(heightLinevalue,data){
        var max=Math.max.apply( Math, data );
        if(heightLinevalue === null|| heightLinevalue===""){
          return max;
        }else if(heightLinevalue>max){
          return heightLinevalue;
        }else{
          return max;
        }
      },
      queryLineData() {
        this.option = {}
        this.option2 = {}
        let params = {deviceId: this.uniqueParam.deviceId,beginDate: this.queryParam.beginDate,endDate: this.queryParam.endDate}
        getAction(this.url.queryPmMeterdatarecordLineStatistical, params).then((res) => {
          if(res.success){
            this.lineData= res.result;
            let max = this.setLineMax(this.model.tepvalueTop,this.lineData.tList);
            this.drawTempLine(max);
            if(this.model.deviceType == 'PM'){
              let max = this.setLineMax(this.model.pvalueTop,this.lineData.pList);
              this.drawPressLine(max);
            }else{
              let max = this.setLineMax(this.model.pvalueTop,this.lineData.pList);
              this.drawWaterLine(max);
            }
          }
        })
      },
      drawTempLine(max){ 
        let option = {
          title : {
            text: this.$t('温度曲线图'),
            x: '10px',
            y : '10px',
            textStyle:{
              //color:'white'
              fontSize:'14px',
            },       
          },
          tooltip: {
            trigger: 'axis'
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            splitLine:false,
            data:this.lineData.dateList,
          },
          yAxis: {
            name: '℃',
            type: 'value',
            splitNumber:6,
            max: max,
          },
          // visualMap: {
          //   show: false,
          //   dimension: 1,
          //   pieces: [
          //     {gte: this.model.tepvalueTop, lte: max, color: 'red'},
          //     {lte: this.model.tepvalueLow, color: 'red'}
          //   ],
          //   outOfRange: {
          //     color: 'green'
          //   }
          // },
          series: [
            {
              name:this.$t('温度'),
              type:'line',
              connectNulls: true,// 是否连接空值
              stack: '总量',
              color:'rgb(86, 101, 200)',
              smooth:true,
              data:this.lineData.tList,
              //将所有横坐标点位显示出来
              showAllSymbol: true,
              //设置折点的大小
              symbolSize: 5,
              //设定为实心点
              symbol: 'circle',
              
            }
          ]
        };
        if(!isNull(this.model.tepvalueLow)||!isNull(this.model.tepvalueTop)) {
          let markLine = {
            silent: true,
            lineStyle: {
              normal: {
                color: 'red',
                type:'dotted',
                //这儿设置安全基线颜色
              }
            },
            data: []
          }
          let visualMap= {
            show: false,
            dimension: 1,
            pieces: [
              
            ],
            outOfRange: {
              color: 'green'
            }
          }
          if(!isNull(this.model.tepvalueLow)) {
            markLine.data.push(
              {
                name:this.$t('低位告警线'),
                label: {
                  normal: {
                    show: true,
                    //distance: -100,
                    position: 'insideEndTop',
                    formatter:(params)=>{
                      return this.$t('低位告警线')+':'+params.value;
                    },
                  }
                },type:'min',yAxis: this.model.tepvalueLow,lineStyle: {
                  color: 'orange'}
              }
            )
            visualMap.pieces.push({lte: this.model.tepvalueLow, color: 'red'})
          }
          if(!isNull(this.model.tepvalueTop)) {
            markLine.data.push(
              {
                name:this.$t('高位告警线'),
                label: {
                  normal: {
                    show: true,
                    //distance: -100,
                    position: 'insideEndTop',
                    formatter:(params)=>{
                      return this.$t('高位告警线')+':'+params.value;
                    },
                  }
                },
                type:'max',yAxis: this.model.tepvalueTop,
                  lineStyle: {
                    color: 'red'}
              }
            )
            visualMap.pieces.push({gte: this.model.tepvalueTop, lte: max, color: 'red'})
          }
          option.series[0].markLine = markLine;
          option.visualMap = visualMap;
        }
        this.option2 = option;
      },
      drawPressLine(max){
        let option = {
          title : {
            text: this.$t('压力曲线图'),
            x: '10px',
            y : '10px',
            textStyle:{
              //color:'white'
              fontSize:'14px',
            },        
          },
          tooltip: {
            trigger: 'axis'
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
                  
          xAxis: {
            type: 'category',
            boundaryGap: false,
            splitLine:false,
            data:this.lineData.dateList,
          },
          yAxis: {
            name: 'MPa',
            type: 'value',
            splitNumber:6,
            minInterval: 0.2,
            //max: this.heightPressLinevalue+1,
            max: max
          },
          // visualMap: {
          //   show: false,
          //   dimension: 1,
          //   pieces: [
          //     {gte: this.model.pvalueTop, lte: max, color: 'red'},
          //     {lte: this.model.pvalueLow, color: 'red'}
          //   ],
          //   outOfRange: {
          //     color: 'green'
          //   }
          // },
          series: [
            {
              name:this.$t('压力'),
              type:'line',
              connectNulls: true,// 是否连接空值
              stack: '总量',
              color:'rgb(70, 166, 245)',
              smooth:true,
              data:this.lineData.pList,
              //将所有横坐标点位显示出来
              showAllSymbol: true,
              //设置折点的大小
              symbolSize: 5,
              //设定为实心点
              symbol: 'circle'
            }
          ]
        };
        if(!isNull(this.model.pvalueLow)||!isNull(this.model.pvalueTop)) {
          let markLine = {
            silent: true,
            lineStyle: {
              normal: {
                color: 'red',
                type:'dotted',
                //这儿设置安全基线颜色
              }
            },
            data: []
          }
          let visualMap= {
            show: false,
            dimension: 1,
            pieces: [
              
            ],
            outOfRange: {
              color: 'green'
            }
          }
          if(!isNull(this.model.pvalueLow)) {
            markLine.data.push(
              {
                name:this.$t('低位告警线'),
                label: {
                  normal: {
                    show: true,
                    //distance: -100,
                    position: 'insideEndTop',
                    formatter:(params)=>{
                      return this.$t('低位告警线')+':'+params.value;
                    },
                  }
                },type:'min',yAxis: this.model.pvalueLow,lineStyle: {
                  color: 'orange'}
              }
            )
            visualMap.pieces.push({lte: this.model.pvalueLow, color: 'red'})
          }
          if(!isNull(this.model.pvalueTop)) {
            markLine.data.push(
              {
                name:this.$t('高位告警线'),
                label: {
                  normal: {
                    show: true,
                    //distance: -100,
                    position: 'insideEndTop',
                    formatter:(params)=>{
                      return this.$t('高位告警线')+':'+params.value;
                    },
                  }
                },
                type:'max',yAxis: this.model.pvalueTop,
                  lineStyle: {
                    color: 'red'}
              }
            )
            visualMap.pieces.push({gte: this.model.pvalueTop, lte: max, color: 'red'})
          }
          option.series[0].markLine = markLine;
          option.visualMap = visualMap;
        }
        this.option = option;
      },
      drawWaterLine(max){
        let option = {
          title : {
            text: this.$t('液位曲线图'),
            x: '10px',
            y : '10px',
            textStyle:{
              //color:'white'
              fontSize:'14px',
            },           
          },
          tooltip: {
            trigger: 'axis'
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            splitLine:false,
            data:this.lineData.dateList,
          },
          yAxis: {
            name: 'm',
            type: 'value',
            splitNumber:6,
            minInterval: 0.2,
            max: max,
          },
          visualMap: {
            show: false,
            dimension: 1,
            pieces: [
              {gte: this.model.pvalueTop, lte: max, color: 'red'},
              {lte: this.model.pvalueLow, color: 'red'}
            ],
            outOfRange: {
              color: 'green'
            }
          },
          series: [
            {
              name:this.$t('液位'),
              type:'line',
              connectNulls: true,// 是否连接空值
              stack: '总量',
              color:'rgb(70, 166, 245)',
              smooth:true,
              data:this.lineData.pList,
              //将所有横坐标点位显示出来
              showAllSymbol: true,
              //设置折点的大小
              symbolSize: 5,
              //设定为实心点
              symbol: 'circle'
            }
          ]
        };
        if(!isNull(this.model.pvalueLow)||!isNull(this.model.pvalueTop)) {
          let markLine = {
            silent: true,
            lineStyle: {
              normal: {
                color: 'red',
                type:'dotted',
                //这儿设置安全基线颜色
              }
            },
            data: []
          }
          let visualMap= {
            show: false,
            dimension: 1,
            pieces: [
              
            ],
            outOfRange: {
              color: 'green'
            }
          }
          if(!isNull(this.model.pvalueLow)) {
            markLine.data.push(
              {
                name:this.$t('低位告警线'),
                label: {
                  normal: {
                    show: true,
                    //distance: -100,
                    position: 'insideEndTop',
                    formatter:(params)=>{
                      return this.$t('低位告警线')+':'+params.value;
                    },
                  }
                },type:'min',yAxis: this.model.pvalueLow,lineStyle: {
                  color: 'orange'}
              }
            )
            visualMap.pieces.push({lte: this.model.pvalueLow, color: 'red'})
          }
          if(!isNull(this.model.pvalueTop)) {
            markLine.data.push(
              {
                name:this.$t('高位告警线'),
                label: {
                  normal: {
                    show: true,
                    //distance: -100,
                    position: 'insideEndTop',
                    formatter:(params)=>{
                      return this.$t('高位告警线')+':'+params.value;
                    },
                  }
                },
                type:'max',yAxis: this.model.pvalueTop,
                  lineStyle: {
                    color: 'red'}
              }
            )
            visualMap.pieces.push({gte: this.model.pvalueTop, lte: max, color: 'red'})
          }
          option.series[0].markLine = markLine;
          option.visualMap = visualMap;
        }
        this.option = option;
      },
    }
  }
</script>